// src/locales/si/common.js
export const common = {
  id: "හැඳුනුම්පත",
  save: "සුරකින්න",
  cancel: "අවලංගු",
  info: "තොරතුරු",
  delete: "Delete කරන්න",
  edit: "සංස්කරණය",
  create: "සාදන්න",
  update: "යාවත්කාලීන කරන්න",
  updating: "යාවත්කාලීන කරමින්...",
  creating: "සාදමින්...",
  search: "සෙවීම",
  loading: "පූරණය වෙමින්...",
  processing: "සකසමින්...",
  yes: "ඔව්",
  no: "නැත",
  ok: "හරි",
  back: "ආපසු",
  next: "ඊළඟ",
  previous: "කලින්",
  pageOf: "පිටුව {{page}} / {{total}}",
  submit: "එය සලකුණක් කරන්න",
  reset: "යළි සකසන්න",
  clear: "ඉවත් කරන්න",
  close: "වෙත වසන්න",
  open: "විවෘත කරන්න",
  view: "බලන්න",
  download: "බාගත කරන්න",
  print: "මුද්‍රණය කරන්න",
  printReceipt: "රිසිට්පත මුද්‍රණය කරන්න",
  export: "අපනයනය",
  upload: "උඩුගත කරන්න",
  required: "අවශ්‍යයි",
  optional: "විකල්පයි",
  select: "තෝරන්න",
  selectAll: "සියල්ල තෝරන්න",
  deselectAll: "තෝරාගත් සියල්ල ඉවත් කරන්න",
  actions: "ක්‍රියා",
  status: "තත්ත්වය",
  active: "සක්‍රිය",
  inactive: "අක්‍රිය",
  enabled: "සබල කර ඇත",
  disabled: "අබල කර ඇත",
  or: "නැතහොත්",
  moreActions: "අමතර ක්‍රියා",
  retry: "නැවත උත්සාහ කරන්න",
  refresh: "නැවුම් කරන්න",
  clearSearch: "සෙවීම clear කරන්න",
  clearFilters: "Filters clear කරන්න",
  filter: "පෙරහන",
  success: "සාර්ථකයි",
  goBack: "ආපසු යන්න",
  created: "සාදන ලදී",
  createdBy: "සාදන ලද්දේ",

  // Pagination
  sortBy: "අනුපිළිවෙළ",
  showingResults: "{{start}} සිට {{end}} දක්වා පෙන්වයි (එකතුව: {{total}})",
  page: "පිටුව",
  of: "හි",
  perPage: "පිටුවකට",
  firstPage: "පළමු පිටුව",
  lastPage: "අවසන් පිටුව",
  nextPage: "ඊළඟ පිටුව",
  previousPage: "කලින් පිටුව",

  selectedCount: "{{count}} ක් තෝරාගත්",
  selected: "තෝරාගත්",
  secondsAgo: "තත්පර {{count}} කට පෙර",
  minutesAgo: "මිනිත්තු {{count}} කට පෙර",
  hoursAgo: "පැය {{count}} කට පෙර",
  daysAgo: "දින {{count}} කට පෙර",
  monthsAgo: "මාස {{count}} කට පෙර",
  yearsAgo: "අවුරුදු {{count}} කට පෙර",
  shop: "වෙළඳසැල",
  inStock: "තොගයේ ඇත",
  outOfStock: "තොගයෙන් අවසන්",
  na: "නැත",
  clearAll: "සියල්ල ඉවත් කරන්න",
  show: "පෙන්වන්න",
  hide: "සඟවන්න",

  // Actions
  confirm: "තහවුරු කරන්න",
  confirmUpdate: "යාවත්කාලීනය තහවුරු කරන්න",

  // States  
  readOnly: "කියවීම පමණක්",

  // Messages
  error: "දෝෂයක්",
  validationError: "වලංගුකරණ දෝෂය",
  notAvailable: "නැත",

  // Table / report labels
  count: "ගණන",
  total: "එකතුව",

  // Clipboard
  copy: "පිටපත් කරන්න",
  copiedToClipboard: "Clipboard වෙත පිටපත් කරන ලදී!",
  copyFailed: "පිටපත් කිරීමට නොහැකි විය",

  // Bulk import (shared across bulk order / bulk product import flows)
  bulkDragDropFile: "ඔබේ Excel ගොනුව මෙහි ඇද දමන්න",
  bulkOrClickToSelect: "නැතහොත් ගොනුවක් තෝරාගැනීමට ක්ලික් කරන්න",
  bulkSupportedFormats: "සහාය දක්වන ආකෘති: .xlsx, .xls, .csv",
  bulkFileUploaded: "ගොනුව සාර්ථකව උඩුගත කරන ලදී",
  bulkInvalidFileFormat: "වලංගු නොවන ගොනු ආකෘතියකි. කරුණාකර .xlsx, .xls හෝ .csv ගොනුවක් උඩුගත කරන්න",
  bulkFileParsingError: "ගොනුව විග්‍රහ කිරීමේ දෝෂයකි. කරුණාකර ගොනු ආකෘතිය පරීක්ෂා කරන්න",
  loadingData: "දත්ත පූරණය වෙමින්...",
  viewDetails: "විස්තර බලන්න",
  createdDate: "සාදන ලද දිනය",
  none: "කිසිවක් නැත",
  excel: "Excel",
  saving: "සුරකිමින්",
  uploading: "උඩුගත කරමින්...",
  ref: "යොමුව",
  saveChanges: "වෙනස්කම් සුරකින්න",
  duplicate: "අනුපිටපත් කරන්න",
  continue: "ඉදිරියට",
  clearSelection: "තේරීම ඉවත් කරන්න",
  applyToAll: "සියල්ලටම යොදන්න",
  all: "සියල්ල",
  updatedAt: "යාවත්කාලීන කළේ",
  accessDenied: "ප්‍රවේශය ප්‍රතික්ෂේප විය",
  country: "රට",
  unsavedChangesTitle: "සුරකින නොලද වෙනස්කම්",
  leave: "ඉවත් වන්න",
  stay: "රැඳී සිටින්න",
};
